module.exports = __webpack_public_path__ + "static/media/cardiology_dropdown.59b4bf2f.svg";